module.exports = __webpack_public_path__ + "static/media/seek-backward-15.4e7a53d0.svg";